import { css } from 'styled-components';

export const GardenSkin = css`
  background-color: #8bac0f;
  border: 2px solid #0f380f;
`;

export const GardenWrapperSkin = css`
  background: #306230;
`;

export const GardenLetterSkin = css<{ $isActive: boolean }>`
  color: ${props => (props.$isActive ? '#0f380f' : '#306230')};
  opacity: ${props => (props.$isActive ? 1 : 0.3)};
`;
